import React from "react";
import { Input } from "antd";

import fieldIcon from "./fieldIcons";

/* Control only — `ResourceForm` owns the label, the required marker and the error via
   `<Form.Item>`. The leading icon reads like the mockups' `.ctl` glyph. */
export default function TextField({ field, value, onChange }) {
  return (
    <Input prefix={fieldIcon(field)} value={value ?? ""} placeholder={field.placeholder || ""} onChange={event => onChange(field.name, event.target.value)} />
  );
}
